import { render } from "./RouterLinkAuth.vue?vue&type=template&id=6c4be13b"
import script from "./RouterLinkAuth.vue?vue&type=script&lang=ts"
export * from "./RouterLinkAuth.vue?vue&type=script&lang=ts"
script.render = render

export default script